import React from "react";
import { Form } from "react-bootstrap";
import "./Input.css";

const Input = (props) => {
  return <Form.Group className={"form_group"}>{props.children}</Form.Group>;
};
export default Input;
